module.exports = __webpack_public_path__ + "4245c700388893a3a932eaeddb3db978.pdf";